import { render, staticRenderFns } from "./LatestStatusList.vue?vue&type=template&id=a5adc1d0&scoped=true&"
import script from "./LatestStatusList.vue?vue&type=script&lang=js&"
export * from "./LatestStatusList.vue?vue&type=script&lang=js&"
import style0 from "./LatestStatusList.vue?vue&type=style&index=0&id=a5adc1d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5adc1d0",
  null
  
)

export default component.exports